import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import InvoiceTableRow from './InvoiceTableRow';

@inject('userStore')
@withRouter
@observer
class Invoices extends Component {
    render() {
        // if (!this.state.invoices) return <div>Loading</div>;
        const {invoices, modalHandler, event} = this.props;
        // const {invoices} = this.state;
        return (
              <div className="card card-outline-secondary">
                  <h4 className="card-title card-title-bold"><i className="fa fa-money"></i> Invoices & Payments</h4>
                  {invoices.filter((invoice) => !invoice.is_paid).length > 0 ?
                    <div className="alert alert-warning fade show" role="alert">
                        <strong>Payment Due</strong><br/> You have an invoice payment to make.  This message will go away once payment has been received. Click the Pay button to see payment options.  See below.
                    </div>
                  : null}
                  <table className="table">
                      <thead>
                          <tr>
                              <th width="5%">#</th>
                              <th width="45%">Description</th>
                              <th width="15%">Status</th>
                              <th width="35%" className="text-right">Actions</th>
                          </tr>
                      </thead>
                      <tbody>
                      {invoices.length > 0 ? invoices.map((invoice, index) =>
                        <InvoiceTableRow key={index} invoice={invoice} event={event} modalHandler={modalHandler}/>
                      ) : <tr><td colSpan="4">No Invoices</td></tr>}
                      </tbody>
                  </table>
              </div>
    );}
}


export default Invoices;



// WEBPACK FOOTER //
// ./src/components/client/Invoices.js